import * as types from './mutation-types'

const namespaced = true

const initialState = {
  chamber: 'house',
  mode: 'gop',
  session: {}
}

const mutations = {
  [types.SET_CHAMBER] (state, chamber) {
    state.chamber = chamber
  },
  [types.SET_MODE] (state, mode) {
    state.mode = mode
  },
  [types.SAVE_SESSION] (state, session) {
    state.session = session
  }
}

const actions = {
  setChamber: ({ commit }, chamber) => (
    commit(types.SET_CHAMBER, chamber)
  ),
  setMode: ({ commit }, mode) => (
    commit(types.SET_MODE, mode)
  ),
  saveSession: ({ commit }, session) => {
    commit(types.SAVE_SESSION, session)
  }
}

const getters = {
  chamber (state) {
    return state.chamber
  },
  mode (state) {
    return state.mode
  },
  session (state) {
    return state.session
  }
}

export default {
  namespaced,
  state: initialState,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/modules/calculator.js